/* eslint-disable no-shadow, no-param-reassign */
import axios from "axios";
import swal from "sweetalert2";

const state = () => ({
  cartItems: [],
  currency: null,
  numberOfItems: null,
  orderTotal: null,
  itemTableLoading: true,
  cartLoading: true,
  error: false,
});

const getters = {
  getCartLoading: (state) => {
    return state.cartLoading;
  },

  getCartItemByItemId: (state, itemId) => {
    return state.cartItems.find((cartItem) => cartItem.itemId === itemId);
  },

  getCartItems: (state) => {
    return state.cartItems;
  },

  getCurrency: (state) => {
    return state.currency;
  },

  getNumberOfItems: (state) => {
    return state.numberOfItems;
  },

  getOrderTotal: (state) => {
    return state.orderTotal;
  },

  getItemTableLoading: (state) => {
    return state.itemTableLoading;
  },
};

const actions = {
  async removeTestDrive({ commit }, { subscriberId, cartId }) {
    let response;
    try {
      response = await axios.post(`/item/remove`, {
        subscriberId,
        cartId,
      });
      if (response.status === 200) {
        commit("SET_CART_ITEMS", response.data.cartItems);
        commit("SET_NUMBER_OF_ITEMS", response.data.numberOfItems);
        commit("SET_ORDER_TOTAL", response.data.orderTotal);
      }
      return response;
    } catch (error) {
      return response;
    }
  },

  getCartItems({ commit }) {
    commit("SET_ITEM_TABLE_LOADING", true);
    axios
      .get(`/item/list`)
      .then((res) => {
        commit("SET_CART_ITEMS", res.data.cartItems);
        commit("SET_NUMBER_OF_ITEMS", res.data.numberOfItems);
        commit("SET_ORDER_TOTAL", res.data.orderTotal);
        commit("SET_CURRENCY", res.data.currency);
      })
      .catch((err) => {
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to update your cart!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
        });
        commit("SET_ERROR", err.message);
      })
      .finally(() => {
        commit("SET_ITEM_TABLE_LOADING", false);
        commit("SET_CART_LOADING", false);
      });
  },
  updateCartItemQuantity({ commit }, { itemId, quantity }) {
    commit("SET_ITEM_TABLE_LOADING", true);
    axios
      .post(`/item/update`, { itemId, quantity })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.errors) {
            commit("SET_ERROR", response.data.errors);
            swal.fire({
              title: "Uh oh..",
              type: "error",
              html: `<p style="font-size: small">We were unable to update your cart!</p>
            <p style="font-size: small">${response.data.errors}</p>
            <p style="font-size: small">Please refresh your page and try again.</p>`,
            });
          } else {
            commit("SET_CART_ITEMS", response.data.cartItems);
            commit("SET_NUMBER_OF_ITEMS", response.data.numberOfItems);
            commit("SET_ORDER_TOTAL", response.data.orderTotal);
            swal.fire({
              title: "Success!",
              type: "success",
              html: `<p style="font-size: small">Quantity updated successfully!</p>`,
            });
          }
        }
      })
      .catch((err) => {
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to update your cart!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
        });
        commit("SET_ERROR", err.message);
      })
      .finally(() => {
        commit("SET_ITEM_TABLE_LOADING", false);
      });
  },
  deleteCartItem({ commit }, itemId) {
    commit("SET_ITEM_TABLE_LOADING", true);
    axios
      .post(`/item/delete`, { itemId })
      .then((res) => {
        commit("SET_CART_ITEMS", res.data.cartItems);
        commit("SET_NUMBER_OF_ITEMS", res.data.numberOfItems);
        commit("SET_ORDER_TOTAL", res.data.orderTotal);
      })
      .catch((err) => {
        swal.fire({
          title: "Uh oh..",
          type: "error",
          html: `<p style="font-size: small">We were unable to update your cart!</p>
            <p style="font-size: small">Please refresh your page and try again.</p>
          `,
        });
        commit("SET_ERROR", err.message);
      })
      .finally(() => {
        commit("SET_ITEM_TABLE_LOADING", false);
      });
  },
};
const mutations = {
  SET_CART_LOADING(state, value) {
    state.cartLoading = value;
  },

  SET_CART_ITEMS(state, value) {
    state.cartItems = value;
  },

  SET_ERROR(state, value) {
    state.error = value;
  },

  SET_CURRENCY(state, value) {
    state.currency = value;
  },

  SET_NUMBER_OF_ITEMS(state, value) {
    state.numberOfItems = value;
  },

  SET_ORDER_TOTAL(state, value) {
    state.orderTotal = value;
  },

  SET_ITEM_TABLE_LOADING(state, value) {
    state.itemTableLoading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
